import React, { useEffect, useState, useRef } from "react";
import get from "lodash/get";
import { object, func, string } from "prop-types";
import { connect } from "react-redux";

import AuthorDetails from "../AuthorDetails";
import { getStoryDate, stripMillisecondsFromTime } from "../../utils/utils";
import { PublisedTimeToggler } from "../../atoms/icons/StoryPageIcons";
import { setMetypeBar, setSocialShare } from "../../helper/actions";
import { staticTexts } from "../../utils/Translate";
import { getAuthorObj } from "../../helper/api";
import StoryPageMetaDataIcons from "../StoryPageMetaDataIcons";

import "./storyPageMetaData.m.css";

const StoryPageMetaData = ({ story, lang, setSocialShare, timezone }) => {
  const [authors, setAuthors] = useState([]);
  const authorDisplayName = get(story, ["metadata", "story-attributes", "author-display-name", "0"], null);
  const datePublished = stripMillisecondsFromTime(new Date(story["first-published-at"]), timezone);

  const englishWrapperName = lang === "en" ? "en-author-wrapper" : "";

  const [timeType, setTimeType] = useState(true); // true->show publised date, false->update date
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setSocialShare(false);
    }
  };

  const publishedTimeClick = () => {
    if (story["first-published-at"] !== story["last-published-at"]) {
      setTimeType(!timeType);
    }
  };

  const fetchAuthorObjects = async () => {
    const authorsArray = await Promise.all(story.authors.map((item) => getAuthorObj(item.id)));
    setAuthors(authorsArray);
  };

  useEffect(() => {
    if (global.deviceWidth > 876) {
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      };
    }
  });

  useEffect(() => {
    fetchAuthorObjects();
  }, []);

  return (
    <div styleName="wrapper">
      <div styleName={`author-read-time-wrapper ${englishWrapperName}`} className="author-read-time-wrapper">
        <AuthorDetails
          story={story}
          authors={authors}
          authorDisplayName={authorDisplayName}
          withAvatar={false}
          contributorType={7}
          authorDetailsType={"story-page-author-details"}
          lang={lang}
        />
      </div>
      <div
        styleName={`time-social-share-wrapper ${lang === "en" ? "en-time-social-share-wrapper" : ""}`}
        className="time-social-share-wrapper"
      >
        {story["first-published-at"] !== story["last-published-at"] ? (
          <div onClick={publishedTimeClick} styleName="publish-time">
            <time dateTime={datePublished}>
              {timeType
                ? `${staticTexts(lang).updatedAt}: ${
                    story["last-published-at"] ? getStoryDate(story["last-published-at"], lang, "story-page") : ""
                  } `
                : `${staticTexts(lang).publishedAt}: ${
                    story["first-published-at"] ? getStoryDate(story["first-published-at"], lang, "story-page") : ""
                  } `}
            </time>
            <PublisedTimeToggler />
          </div>
        ) : (
          <div styleName="publish-time no-update">
            <time dateTime={datePublished}>{`${staticTexts(lang).publishedAt}: ${
              story["first-published-at"] ? getStoryDate(story["first-published-at"], lang, "story-page") : ""
            } `}</time>
          </div>
        )}
        <StoryPageMetaDataIcons />
      </div>
    </div>
  );
};

StoryPageMetaData.propTypes = {
  story: object.isRequired,
  setMetypeBar: func,
  color1: string,
  color2: string,
  lang: string,
  setSocialShare: func,
  timezone: string,
};

const mapStateToProps = (state) => ({
  timezone: get(state, ["qt", "data", "timezone"], "Asia/Dhaka"),
});

const mapDispatchToProps = (dispatch) => ({
  setMetypeBar: (flag) => dispatch(setMetypeBar(flag)),
  setSocialShare: (flag) => dispatch(setSocialShare(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryPageMetaData);
